<template>
  <a
    v-if="orderUuid"
    :href="`/dashboard/order/${orderUuid}`"
    target="_blank"
    rel="noopener noreferrer"
    class="link link-primary hover:underline"
  >
    {{ quoteReference || '-' }}
  </a>
  <span v-else class="text-base-content/60">-</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  data?: any
  params?: any
}

const props = defineProps<Props>()

const arbitration = computed(() => props.data || props.params?.data)
const orderUuid = computed(() => arbitration.value?.triggeringOrder?.uuid)
const quoteReference = computed(() => arbitration.value?.triggeringOrder?.quote?.quoteReference)
</script>
